import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ProductFruits } from 'react-product-fruits'
import { connect } from 'react-redux'

class ProductFruitsContainer extends Component {

  state = {
    hasConsented: false
  }

  componentDidMount () {
    window.addEventListener('ccm19WidgetClosed', this.handleConsentChange)
    this.handleConsentChange()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    this.handleConsentChange()
  }

  componentWillUnmount () {
    window.removeEventListener('ccm19WidgetClosed', this.handleConsentChange)
  }

  handleConsentChange = () => {
    const newHasConsented = this.hasConsented()
    if (this.state.hasConsented !== newHasConsented) {
      this.setState({ hasConsented: newHasConsented })
    }
  }

  hasConsented () {
    return window?.CCM?.acceptedEmbeddings?.filter(e => e.name === 'Product Fruits').length > 0
  }

  render () {
    if (!this.state.hasConsented || !this.props.isAuthenticated) {
      return null
    }
    return (
      <ProductFruits
        workspaceCode={this.props.workspaceCode} language="en"
        lifeCycle={'unmount'}
        user={{
          username: this.props.user.userId,
          email: this.props.user.user
        }}
      />
    )
  }
}

ProductFruitsContainer.defaultProps = {}
ProductFruitsContainer.propTypes = {
  workspaceCode: PropTypes.string.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
}
const mapStateToProps = state => ({
  user: state.user,
  isAuthenticated: !!state.user.loggedIn,
})
export default connect(mapStateToProps, {})(ProductFruitsContainer)
